<template>
  <vertical-modal
    :visible="modelValue"
    body-class="tw-p-4"
    @close="close"
    header-title="ویرایش بار"
  >
    <template #body>
      <div
        style="height: 300px"
        class="text-center d-flex"
        v-if="store.loading_get_order"
      >
        <div class="m-auto">
          درحال خواندن اطلاعات
          <dots-loading />
        </div>
      </div>

      <template v-else>
        <div class="tw-mb-6">
          <p class="mb-1 ms-1 fs-13">ماهیت بار</p>
          <CircleToggle v-model="load_type" :options="bar_opts" :size="30" />
        </div>
<!--        حواله انبار-->
        <template v-if="load_type === 'warehouse_transfer'">
          <div class="tw-mb-6">
            <BaseSelect
              :options="warehouses_options"
              :loading="get_warehouses_loading"
              :disabled-options="[dest_warehouse]"
              v-model="origin_warehouse"
              :float-title="true"
              title="انبار مبدا"
              placeholder="انتخاب انبار مبدا"
            />
          </div>
          <div class="tw-mb-6">
            <BaseSelect
              :options="warehouses_options"
              :loading="get_warehouses_loading"
              :disabled-options="[origin_warehouse]"
              v-model="dest_warehouse"
              :float-title="true"
              title="انبار مقصد"
              placeholder="انتخاب انبار مقصد"
            />
          </div>
        </template>

<!--        فاکتور فروش-->
        <template v-else>
          <div class="tw-mb-6">
            <select-users
              title="مشتری"
              placeholder="انتخاب مشتری"
              icon="person"
              v-model="user_id"
            />
          </div>

          <div class="tw-mb-6">
            <BaseSelect
              v-model="type_arz"
              :options="arz_types"
              :float-title="true"
              title="واحد ارزی فروش"
              placeholder="انتخاب واحد ارزی فروش"
            />
          </div>

          <template v-if="type_arz !== 'IRR' && type_arz !== ''">
            <div class="tw-mb-6">
              <input-ayandeh
                :number-format="true"
                v-model:value="price_arz"
                :placeholder="'نرخ ' + type_arz_title"
                dir="ltr"
                :float-label="'نرخ ' + type_arz_title + ' ریال'"
              />
            </div>

            <div class="tw-mb-6">
              <input-ayandeh
                v-model:value="price_per_ton_arz"
                :placeholder="'فی فروش به ' + type_arz_title"
                dir="ltr"
                :float-label="'فی فروش به ' + type_arz_title"
              />
            </div>
          </template>

          <div class="tw-mb-6" v-else>
            <input-ayandeh
              :number-format="true"
              v-model:value="price_per_ton"
              placeholder="فی فروش"
              label="فی فروش ریال"
              dir="ltr"
            />
          </div>

        </template>
      </template>
    </template>

    <template #footer>
      <btn-ayandeh
        @click="close"
        label="انصراف"
        color="light"
        :disabled="loading_update"
      />
      <btn-ayandeh
        @click="update_order"
        label="ذخیره"
        :loading="loading_update"
      />
    </template>
  </vertical-modal>
</template>

<script setup>
import { onMounted, ref, watch, computed } from 'vue'
import VerticalModal from '@/components/base/VerticalModal.vue'
import BaseIcon from '@/components/base/BaseIcon.vue'
import { useStore } from 'vuex'
import InputAyandeh from '@/components/inputs/InputAyandeh.vue'
import Currency from '@/components/partial/Currency.vue'
import CircleToggle from '@/components/base/CircleToggle.vue'
import axios from 'axios'
import BaseSelect from '@/components/base/select/BaseSelect.vue'
import SelectUsers from '@/components/base/select/SelectUsers.vue'
import { apiGetWarehouses } from '@/services/loads/LoadingService'

const store = useStore()
// let load_object = ref(props.load || null)
let load_object = ref('')
let user_id = ref('')
let price_per_ton = ref('')
let type_arz = ref('IRR')
let price_arz = ref('')
let price_per_ton_arz = ref('')
let loading_update = ref(false)
const arz_types = [
  {
    value: 'IRR',
    label: 'ریال',
  },
  {
    value: 'USD',
    label: 'دلار',
  },
  {
    value: 'PKR',
    label: 'روپیه',
  },
  {
    value: 'AFN',
    label: 'افغانی',
  },
]
let load_type = ref('')
const bar_opts = [
  { label: 'حواله انبار', value: 'warehouse_transfer' },
  { label: 'فاکتور فروش', value: 'sale_invoice' },
]
const get_warehouses_loading = ref(false)
let warehouses = ref([])
const origin_warehouse = ref(null)
const dest_warehouse = ref(null)

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  id: { type: Number, default: null },
  load: { type: Object, default: null },
})

const emit = defineEmits(['update:visible', 'close', 'updated'])

const get_site_users = () => store.dispatch('get_site_users')
const get_order = (id) => store.dispatch('get_order', id)

const close = () => {
  emit('update:modelValue', false)
  emit('close', true)
}

onMounted(() => {
  if (props.load) {
    load_object.value = props.load
  }
  getWarehouses()
})

const type_arz_title = computed(() => {
  return arz_types.find((a) => a.value === type_arz.value)?.label || ''
})

const update_order = () => {
  loading_update.value = true

  const data = {
    id: load_object.value.id,
    user_id: user_id.value,
    type_arz: type_arz.value,
    price_arz: price_arz.value,
    price_per_ton_arz: price_per_ton_arz.value,
    price_per_ton: price_per_ton.value,
    load_type: load_type.value,
    origin_warehouse: origin_warehouse.value || null,
    destination_warehouse: dest_warehouse.value || null,
  }

  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  }
  // eslint-disable-next-line no-undef
  axios.post('/orders/easy_update', data, config).then((response) => {
    if (response?.data.status === 'success') {
      emit('updated', {
        load_detail_template: response.data.load_detail_template,
        load_list_template: response.data.load_list_template,
      })
      close()
    }
    loading_update.value = false
  })
}

const warehouses_options = computed(() => {
  return warehouses.value.map((item) => {
    return {
      value: item.Cod,
      label: item.Nam,
    }
  })
})

const getWarehouses = async () => {
  get_warehouses_loading.value = true
  try {
    const response = await apiGetWarehouses()
    if (!response) return

    warehouses.value = response.data?.data
  } finally {
    get_warehouses_loading.value = false
  }
}

watch(
  () => props.modelValue,
  (val) => {
    if (val) {
      if (props.id && !store.state.order) {
        get_order(props.id)
      }

      if (
        !store.state.site_users_options ||
        store.state.site_users_options.length === 0
      ) {
        get_site_users()
      }
    }
  },
)

watch(
  () => store.state.order,
  (val) => {
    if (val) {
      load_object.value = val
    }
  },
)


// watch(
//   () => load_type.value,
//   (val) => {
//     if (val === 'warehouse_transfer' && !warehouses.value.length)
//       getWarehouses()
//   },
// )

watch(
  () => props.load,
  (val) => {
    if (val) {
      load_object.value = val
    }
  },
  { immediate: true },
)

watch(
  () => load_object.value,
  (val) => {
    price_per_ton_arz = ref(val?.price_per_ton_arz || '')
    type_arz = ref(val?.type_arz || '')
    price_arz = ref(val?.price_arz || '')
    price_per_ton = ref(val?.price_per_ton || '')
    user_id = ref(val?.user_id || '')
    load_type.value = val.load_type || null
    origin_warehouse.value = val.origin_warehouse_id?.toString() || null
    dest_warehouse.value = val.destination_warehouse_id?.toString() || null
  },
  { immediate: true },
)
</script>

<style scoped></style>
